export default __webpack_public_path__ + "static/csv/HomeTiles.a0d5d611.csv";